<template>
  <v-col class="comments pb-16 transparent">
    <v-row no-gutters class="mx-2 mb-6 pt-1">
      <v-col cols="auto" align-self="center">
        <label for="add-comment" class="pl-3 pr-4">
          <v-icon color="primary" size="30">mdi-camera</v-icon>
        </label>
      </v-col>
      <v-col align-self="center">
        <v-textarea
          hide-details
          outlined
          rounded
          dense
          placeholder="Add a comment"
          auto-grow
          background-color="white"
          v-model="text"
          rows="1"
        ></v-textarea>
      </v-col>
      <v-col cols="auto" align-self="center">
        <v-btn
          class="ml-3 mr-1"
          icon
          @click="sendComment()"
          :loading="commentPending"
          :disabled="commentPending"
          ><v-icon color="primary">mdi-send</v-icon></v-btn
        >
      </v-col>
    </v-row>
    <transition-group name="list-complete" style="width: 100%">
      <div
        v-for="(comment, index) in comments"
        :key="comment.id"
        class="list-complete-item"
      >
        <v-row no-gutters class="mx-4">
          <v-col cols="auto"
            ><v-row
              no-gutters
              @click="$router.push(`/garden/${comment.userId}`)"
              ><v-col
                ><v-img
                  :src="comment.profilePictureUrl"
                  class="primary rounded-circle shrink"
                  width="40"
                  height="40"
                  transition="fade-transition"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0 primary"
                      align="center"
                      justify="center"
                    >
                      <v-icon size="20" color="white">mdi-account</v-icon>
                    </v-row>
                  </template>
                </v-img></v-col
              ></v-row
            ><v-row no-gutters justify="center">
              <v-btn
                v-if="self.id === comment.userId"
                icon
                class="error--text mt-1"
                @click="deleteComment(comment)"
                ><v-icon>mdi-delete-outline</v-icon></v-btn
              >
            </v-row> </v-col
          ><v-col class="pl-2" style="width: calc(100% - 50px)"
            ><v-row
              no-gutters
              class="text-body-2 font-weight-bold my-0 py-0"
              @click="$router.push(`/garden/${comment.userId}`)"
            >
              {{
                comment.userNickname ? comment.userNickname : "Anonymous user"
              }}
            </v-row>
            <v-row no-gutters class="text-caption my-0 mt-n1 mb-2">
              {{ handleISOToRelativeTime(comment.createdAt.toDate()) }}
            </v-row>
            <v-row no-gutters v-if="comment.text">{{ comment.text }}</v-row>
            <v-row no-gutters v-if="comment.pictureUrl"
              ><v-img
                @click="
                  $store.commit('fullScreenPicture/setUrl', comment.pictureUrl)
                "
                :src="comment.pictureUrl"
                max-width="100%"
                max-height="150"
                class="rounded-xl shrink"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </v-row>
                </template> </v-img></v-row
          ></v-col>
        </v-row>
        <v-divider
          class="my-4 mx-4"
          v-if="index != comments.length - 1"
        ></v-divider>
      </div>
    </transition-group>
    <input
      type="file"
      id="add-comment"
      @change="onFileChange"
      accept="image/*"
      style="display: none"
    />
  </v-col>
</template>

<script>
import { mapState } from "vuex";
import { ISOToRelativeTime } from "@/utils/dates.js";
import resizePicture from "@/utils/resizePicture.js";

export default {
  props: ["target"],
  data() {
    return {
      text: "",
      loadingCamera: false,
      fullScreenPicture: false,
      fullScreenPictureUrl: "",
    };
  },
  computed: {
    ...mapState("self", ["self"]),
    ...mapState("comments", ["comments", "commentPending"]),
  },
  mounted() {
    this.$store.dispatch("comments/getComments", {
      gardenId: this.$route.params.gardenId,
      itemId: this.$route.params.plantId,
    });
  },
  methods: {
    async onFileChange(e) {
      try {
        const dataurl = await resizePicture(e.target.files[0], 1000, 1000);
        this.$store.dispatch("level/updateLevel", {
          field: "comment",
          value: true,
        });
        this.$store.dispatch("comments/uploadCommentPicture", {
          gardenId: this.$route.params.gardenId,
          itemId: this.$route.params.plantId,
          dataurl,
        });
      } catch (error) {
        console.log(error);
      }
    },
    handleISOToRelativeTime(date) {
      return ISOToRelativeTime(date);
    },
    deleteComment(comment) {
      this.$store.dispatch("comments/deleteComment", {
        gardenId: this.$route.params.gardenId,
        itemId: this.$route.params.plantId,
        comment,
      });
    },
    sendComment() {
      if (this.text === "") return;
      this.$store.dispatch("level/updateLevel", {
        field: "comment",
        value: true,
      });

      let comment = {
        text: this.text,
        userId: this.self.id,
        target: this.target,
      };

      if (this.self.profilePictureUrl)
        comment.profilePictureUrl = this.self.profilePictureUrl;
      if (this.self.nickname) comment.userNickname = this.self.nickname;

      this.$store.dispatch("comments/createComment", {
        gardenId: this.$route.params.gardenId,
        itemId: this.$route.params.plantId,
        comment,
      });

      this.text = "";
    },
  },
};
</script>


<style>
.list-complete-item {
  transition: all 0.5s;
}
.list-complete-enter,
.list-complete-leave-to {
  opacity: 0;
  transform: translateY(-50px);
}
.list-complete-leave-active {
  position: absolute;
  z-index: -1;
}
</style>